// Pagination Skeleton
export const PaginationSkeleton = () => {
  return (
    <div className="flex animate-pulse items-center space-x-2">
      {/* Left Arrow Skeleton */}
      <div className="h-8 w-8 rounded border border-gray-300 bg-gray-200" />
      {/* Page Number Skeleton */}
      {[...Array(3)].map((_, i) => (
        <div
          key={i}
          className="h-8 w-9 rounded-[6px] border border-gray-300 bg-gray-200"
        />
      ))}
      {/* Right Arrow Skeleton */}
      <div className="h-8 w-8 rounded border border-gray-300 bg-gray-200" />
      {/* Items Per Page Dropdown Skeleton */}
      <div className="ml-4 h-10 w-20 rounded border border-gray-300 bg-gray-200" />
    </div>
  );
};
